import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2 } from 'lucide-react';
import { axiosInstance } from '@/axiosConfig';
import { toast } from 'sonner';

export default function EditAgenciaModal({ isOpen, onClose, agencia, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    plano: '',
    status_assinatura: '',
    limite_usuarios: 0
  });

  // Preenche o formulário quando a agência é selecionada
  useEffect(() => {
    if (agencia) {
      setFormData({
        plano: agencia.plano || 'FREE',
        status_assinatura: agencia.status_assinatura || 'ATIVA',
        limite_usuarios: agencia.usuarios_count > (agencia.limite_usuarios || 1) 
            ? agencia.usuarios_count 
            : (agencia.limite_usuarios || 1)
      });
    }
  }, [agencia]);

  const handleSave = async () => {
    setLoading(true);
    try {
        await axiosInstance.patch(`/admin-saas/agencias/${agencia.id}`, {
            plano: formData.plano,
            status_assinatura: formData.status_assinatura,
            limite_usuarios: parseInt(formData.limite_usuarios)
        });
        
        toast.success("Dados da agência atualizados!");
        onSuccess(); // Recarrega a tabela pai
        onClose();
    } catch (error) {
        toast.error("Erro ao atualizar agência.");
        console.error(error);
    } finally {
        setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Editar Agência: {agencia?.nome}</DialogTitle>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
          
          {/* 1. SELETOR DE STATUS */}
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="text-right">Status</Label>
            <div className="col-span-3">
                <select 
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                    value={formData.status_assinatura}
                    onChange={(e) => setFormData({...formData, status_assinatura: e.target.value})}
                >
                    <option value="ATIVA">Ativa (Liberada)</option>
                    <option value="INADIMPLENTE">Inadimplente (Bloqueio Parcial)</option>
                    <option value="BLOQUEADA">Bloqueada (Acesso Negado)</option>
                    <option value="CANCELADA">Cancelada</option>
                </select>
            </div>
          </div>

          {/* 2. SELETOR DE PLANO */}
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="text-right">Plano</Label>
            <div className="col-span-3">
                <select 
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                    value={formData.plano}
                    onChange={(e) => setFormData({...formData, plano: e.target.value})}
                >
                    <option value="FREE">Free</option>
                    <option value="BASIC">Básico (R$ 97)</option>
                    <option value="PRO">Profissional (R$ 197)</option>
                    <option value="ENTERPRISE">Enterprise (R$ 497)</option>
                </select>
            </div>
          </div>

          {/* 3. LIMITE DE USUÁRIOS */}
          <div className="grid grid-cols-4 items-center gap-4">
            <Label className="text-right">Usuários</Label>
            <Input
              type="number"
              className="col-span-3"
              value={formData.limite_usuarios}
              onChange={(e) => setFormData({...formData, limite_usuarios: e.target.value})}
            />
          </div>
          
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSave} disabled={loading}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2"/> : 'Salvar Alterações'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}